export default "__VITE_ASSET__poxqEMye__"